import XmlFormatter from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/XmlFormatter";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import type { Attrs, Node } from "@tiptap/pm/model";

export const getTableAttrs = (attrs: Attrs) => {
	const sortingOrder = (attrs.sortingOrder as [])?.length > 1 ? (attrs.sortingOrder as []).join(",") : undefined;
	return {
		...attrs,
		sortingOrder,
	};
};

// `colgroup` is metadata, not a row: it shares the line of the opening tag.
const colgroup = (node: Node) => {
	const firstRow = node.firstChild.content;
	if (!firstRow.content.some((cell) => cell.attrs.colwidth)) return "";

	const columns: string[] = [];
	firstRow.forEach((cell) => {
		for (let column = 0; column < (cell.attrs.colspan as number); column++) {
			const width = cell.attrs.colwidth?.[column];
			columns.push(XmlFormatter.openTag("col", width ? { width: width.toString() } : {}, true));
		}
	});

	return `${XmlFormatter.openTag("colgroup")}${columns.join("")}${XmlFormatter.closeTag("colgroup")}`;
};

const tableFormatter: NodeSerializerSpec = async (state, node) => {
	await state.wrapContainer(
		`${XmlFormatter.openTag("table", getTableAttrs(node.attrs))}${colgroup(node)}`,
		XmlFormatter.closeTag("table"),
		node,
		async () => await state.renderStructuralChildren(node),
	);
};

export default tableFormatter;
